<template>
<!--  XXX: this is leaved in case we need to go back to dropdowns -->
<!--  <div class="btn-group">-->
<!--    <button class="btn btn-xs green dropdown-toggle" type="button" data-toggle="dropdown"-->
<!--            aria-expanded="false"> Actions-->
<!--      <i class="fa fa-angle-down"></i>-->
<!--    </button>-->
<!--    <ul class="dropdown-menu" role="menu">-->
<!--      <slot></slot>-->
<!--    </ul>-->
<!--  </div>-->
  <div class="actions-menu">
    <slot></slot>
  </div>
</template>
<script>

export default {
  setup() {

    return {
    }
  }
}
</script>

<style scoped lang="scss">
.actions-menu {
  white-space: nowrap;
}
</style>



// WEBPACK FOOTER //
// ActionsMenu.vue?5a6a574d